import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {ScrollView as DXScrollView} from 'devextreme-react';


export default class ScrollView extends Component {
    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXScrollView
                {...R.omit(['loading_state', 'setProps', 'children'], this.props)}
                {...dataAttributes}
            >
                {this.props.children}
            </DXScrollView>
        );
    }
}

ScrollView.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * A Boolean value specifying whether to enable or disable the bounce-back effect
     */
    bounceEnabled: PropTypes.bool,
    /**
     * A string value specifying the available scrolling directions
     */
    direction: PropTypes.oneOf(['both', 'horizontal', 'vertical']),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when the "pull to refresh" gesture is performed. Supported on mobile devices only
     */
    onPullDown: PropTypes.func,
    /**
     * A function that is executed when the content is scrolled down to the bottom
     */
    onReachBottom: PropTypes.func,
    /**
     * A function that is executed on each scroll gesture
     */
    onScroll: PropTypes.func,
    /**
     * A function that is executed each time the UI component is updated
     */
    onUpdated: PropTypes.func,
    /**
     * Specifies the text shown in the pullDown panel when pulling the content down lowers the refresh threshold
     */
    pulledDownText: PropTypes.string,
    /**
     * Specifies the text shown in the pullDown panel while pulling the content down to the refresh threshold
     */
    pullingDownText: PropTypes.string,
    /**
     * Specifies the text shown in the pullDown panel displayed when content is scrolled to the bottom
     */
    reachBottomText: PropTypes.string,
    /**
     * Specifies the text shown in the pullDown panel displayed when the content is being refreshed
     */
    refreshingText: PropTypes.string,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * A Boolean value specifying whether or not an end-user can scroll the UI component content swiping it up or down. Applies only if useNative is false
     */
    scrollByContent: PropTypes.bool,
    /**
     * Specifies whether a user can scroll the content with the scrollbar. Applies only if useNative is false.
     */
    scrollByThumb: PropTypes.bool,
    /**
     * Specifies when the UI component shows the scrollbar
     */
    showScrollbar: PropTypes.oneOf(['onScroll', 'onHover', 'always', 'never']),
    /**
     * Indicates whether to use native or simulated scrolling
     */
    useNative: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

ScrollView.defaultProps = {
    bounceEnabled: false, // true, false (desktop)
    direction: 'vertical',
    disabled: false,
    elementAttr: {},
    // height: undefined,
    onDisposing: null,
    onInitialized: null,
    onOptionChanged: null,
    onPullDown: null,
    onReachBottom: null,
    onScroll: null,
    onUpdated: null,
    pulledDownText: 'Release to refresh...', //  '' (Material)
    pullingDownText: 'Pull down to refresh...', //  '' (Material)
    reachBottomText: 'Loading...', // '' (Material)
    refreshingText: 'Refreshing...', // '' (Material)
    rtlEnabled: false,
    scrollByContent: false, // true, false (non-touch devices)
    scrollByThumb: true, // false, true (desktop)
    showScrollbar: 'onHover', // 'onScroll', 'onHover' (desktop)
    useNative: false, // true, false (desktop except Mac)
    // width: undefined
};
